<template>
  <div class="record">
    <div class="empty" v-if="hasFetch && !recordList.length">
      <img :src="`${rootCDNUrl}/empty.png`" alt="">
      <p>暂无代金券，快去下载游戏领取吧~</p>
    </div>
    <template v-else>
      <div class="tip">
        <div
          class="tip_icon bg_contain mr_4"
          :style="{ backgroundImage: `url(${rootCDNUrl}/info.png)`}"
        />
        <div class="tip_main fs_13">代金券使用方法：游戏内支付自动使用</div>
      </div>
      <div class="list">
        <div class="item shadow" v-for="i in recordList" :key="i.dispatch_id" :class="{ it_disalbed: [2, 3].includes(i.status) }">
          <div class="it_left flex_a_c d_flex_col">
            <div class="relative flex_a_b">
              <div v-if="i.type === 1" class="it_symbol">￥</div>
              <div class="it_value">{{ i.discount }}</div>
              <div v-if="i.type === 2" class="it_discount">折</div>
            </div>
            <div :class="{ hidden: !i.condition }" class="it_useage fs_13 mt_8">{{ i.condition }}</div>
          </div>
          <div class="it_rip"></div>
          <div class="it_right">
            <div class="it_title mb_8 bold">{{ i.name }}</div>
            <div class="it_desc mb_8 fs_13">适用游戏: {{ $route.query.title }}</div>
            <div class="it_expire fs_12 color_grey">{{ slice016(i.get_time) }}至{{ slice016(i.invalid_time) }}</div>
          </div>
          <img v-if="i.status === 2" :src="`${rootCDNUrl}/used.png`" class="it_has_expired" />
          <img v-if="i.status === 3" :src="`${rootCDNUrl}/expired.png`" class="it_has_expired" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { fetchRecord } from '@/api/voucherAct'
export default {
  data () {
    return {
      rootCDNUrl: '//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/voucherAct',
      recordList: [],
      hasFetch: false,
    }
  },
  computed: {
    params () {
      return this.$route.query || {}
    },
  },
  mounted () {
    document.title = '领取记录'
    this.onFetchRecord()
  },
  methods: {
    onFetchRecord () {
      const { id, gameid } = this.params
      fetchRecord(id, { game_id: gameid }).then(res => {
        this.recordList = res.data
      }).finally(() => {
        this.hasFetch = true
      })
    },
    slice016 (str) {
      return typeof str.slice === 'function' ? str.slice(0, 16) : str
    },
  },
}
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding-top: 130px;
  background-color: #f8f8f8;
  color: #919191;
  img {
    width: 100px;
    margin-bottom: 40px;
  }
}
.tip {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  padding: 6px 24px;
  background: #ffcc82;
  color: #FF601A;
  .tip_icon {
    width: 14px;
    height: 14px;
  }
}

.fs_13 {
  font-size: 13px;
}
.list {
  width: 100%;
  padding: 6px 16px;
}
.item {
  position: relative;
  width: 100%;
  display: flex;
  padding: 8px 12px;
  color: #FF590F;
  background-color: #fae7d6;
  border-radius: 8px;
  .it_left {
    width: 84px;
    justify-content: flex-end;
  }
  .it_right {
    flex: 1;
    .it_title {
      font-size: 19px;
    }
  }
  .it_rip {
    position: relative;
    border-left: 1px dashed #bbb;
    margin-right: 16px;
    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 20px;
      height: 10px;
      left: 0px;
      background-color: #fff;
      pointer-events: none;
    }
    &:before {
      top: 0px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      transform: translate(-50%, calc(-50% - 5px));
    }
    &:after {
      bottom: 0px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      transform: translate(-50%, calc(50% + 5px));
    }
  }
  .it_symbol {
    position: absolute;
    bottom: 2px;
    left: -18px;
    font-size: 18px;
  }
  .it_value {
    font-size: 32px;
    font-weight: bold;
  }
  .it_discount {
    position: absolute;
    bottom: 4px;
    right: -20px;
    font-size: 16px;
  }
  .it_has_expired {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 75px;
  }
}
.item + .item {
  margin-top: 5px;
}
.it_disalbed {
  background-color: #e6e7ec;
  color: #99999A;
}
.shadow {
  box-shadow: 1px 1px 0px 0px rgba(165, 165, 165, 0.60); 
}
.hidden {
  visibility: none;
}
</style>
